export default __webpack_public_path__ + "static/media/instructionForTableOfContent.091d7bec.png";